import PersonApi from '../../api/personApi';

export default {
  state: {
    persons: [],
    contacts: [
      {
        id: 1,
        value: 'test@test.com',
        type: 'email',
        default: true
      }
    ],
    factoryDetail: {
      lfbis: '1234',
      ringNr: 'T 28',
      countryId: 0,
      place: {}
    },
    pigSty: [],
    pigStyOptions: [{
      id: 0,
      name: 'tgd'
    }, {
      id: 1,
      name: 'ama'
    }, {
      id: 2,
      name: 'piglet'
    }, {
      id: 3,
      name: 'babyPiglet'
    }]
  },
  mutations: {

  },
  actions: {
    async PERSON_FETCH(store, { id }) {
      try {
        const response = await PersonApi.fetch(id);
        return Promise.resolve(response.data);
      } catch (error) {
        store.dispatch('NOTIFY_ERROR', error);
        return Promise.reject(error);
      }
    },
    async VETERINARIANS_FETCH(store, { factoryId }) {
      try {
        const response = await PersonApi.fetchVeterinarians(factoryId);
        return Promise.resolve(response.data);
      } catch (error) {
        store.dispatch('NOTIFY_ERROR', error);
        return Promise.reject(error);
      }
    },
    async PERSON_REMOVE(store, { id }) {
      try {
        const response = await PersonApi.remove(id);
        return Promise.resolve(response.data);
      } catch (error) {
        store.dispatch('NOTIFY_ERROR', error);
        return Promise.reject(error);
      }
    },
    PERSON_CREATE(store, {person}) {
      return new Promise((resolve, reject) => {
        PersonApi.create(person).then(response => {
          store.dispatch('NOTIFY_MSG', 'person.notification.create');
          return resolve(response.data);
        }).catch(error => {
          store.dispatch('NOTIFY_ERROR', error);
          return reject(error);
        });
      });
    },
    PERSON_UPDATE(store, {person}) {
      PersonApi.update(person).then(() => {
        store.dispatch('NOTIFY_MSG', 'person.notification.update');
        return Promise.resolve();
      }).catch(error => {
        store.dispatch('NOTIFY_ERROR', error);
        return Promise.reject(error);
      });
    },
    PERSON_ADD_FACTORY(store, { factoryId, personId}) {
      return new Promise((resolve, reject) => {
        PersonApi.addToFactory(factoryId, personId).then(() => {
          resolve();
        }).catch(error => {
          store.dispatch('NOTIFY_ERROR', error);
          return reject(error);
        });
      });
    },
    PERSON_REMOVE_FACTORY(store, { factoryId, personId}) {
      return new Promise((resolve, reject) => {
        PersonApi.removeFromFactory(factoryId, personId).then(() => {
          resolve();
        }).catch(error => {
          store.dispatch('NOTIFY_ERROR', error);
          return reject(error);
        });
      });
    }
  }
}
